import { useBorrowerIsDefendantInLegalActions } from '../../../../../../../queries/BorrowerFields/LegalityFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface DefendentInLegalActionProps {
    required?: boolean;
    isReview?: boolean;
}

export const DefendentInLegalAction: React.FC<DefendentInLegalActionProps> = ({ required = false, isReview = false }) => {
    const label = 'A defendant in any suits or legal actions?';
    const [defendantInLegalActions, set_defendentInLegalActions] = useBorrowerIsDefendantInLegalActions();

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_defendentInLegalActions(true);
                return;
            case 'no':
                set_defendentInLegalActions(false);
                return;
            default:
                set_defendentInLegalActions(undefined);
        }
    };

    const parseDisplayValue = (value: boolean | undefined) => {
        if (value) {
            if (value == true || value == 'true') {
                return 'Yes';
            } else if (value == false || value == 'false') {
                return 'No';
            }
        }
        return undefined;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={parseDisplayValue(defendantInLegalActions)}
                />
            ) : (
                <YesNoToggleButton
                    id='defendantInLegalActions'
                    value={defendantInLegalActions}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Defendent in legal action required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
